import { ValueGetter } from '../../DataGridTableView/CfDataGridTableViewProps';
import { StyledGridHeaderCell } from '../../DataGridTableView/row/row.styles';

export interface CfDataGridHeaderCellProps<TItem> {
  columnIndex: number;
  columnsLength: number;
  getter: ValueGetter<TItem>;
}

export function CfDataGridHeaderCell<TItem>(props: CfDataGridHeaderCellProps<TItem>): JSX.Element {
  const { getter, columnIndex, columnsLength } = props;
  const column = getter.column;

  return (
    <StyledGridHeaderCell
      {...column.headerCellProps}
      sx={{
        ...(columnIndex === 0 && { borderTopLeftRadius: (theme) => theme.shape.borderRadius }),
        ...(columnIndex === columnsLength - 1 && { borderTopRightRadius: (theme) => theme.shape.borderRadius }),

        width: column.width,
        textAlign: column.horizontalAlignment,
        ...column.headerCellProps?.sx,
      }}
    >
      {column.title}
    </StyledGridHeaderCell>
  );
}
